import { ComponentsLayout } from './layout'

export const ModalsPage = () => {
  return (
    <ComponentsLayout 
      title="Modals" 
      description="Componentes de modal e diálogo para interações"
    >
      <div className="text-center py-16">
        <div className="max-w-md mx-auto">
          <div className="bg-white p-8 rounded-lg shadow-sm border">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Em Desenvolvimento
            </h3>
            <p className="text-gray-600 mb-6">
              Os componentes de Modals estão sendo desenvolvidos e estarão disponíveis em breve.
            </p>
            <div className="text-sm text-gray-500">
              🔧 Componente em construção
            </div>
          </div>
        </div>
      </div>
    </ComponentsLayout>
  )
}
